import React from 'react'
import 'gsap'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

function Button({ children, classes, onPress, alternate, noHoverEffect=false }) {
  const animationStyle = {
    transition: ".2s ease-out",
    "&:hover": {
      transform: "translate3d(0,-2px,0)",
    }
  }

  if (typeof onPress === 'string') {
    return (
      <AniLink paintDrip hex="#432609" to={onPress}>
        <button style={animationStyle} onClick={() => null} className={`px-4 font-bold ${alternate ? "bg-transparent text-primary underline border-2 border-primary" : "bg-primary text-white"} ${!noHoverEffect && "hover:shadow-2xl"} rounded-lg ${classes}`}>
        {children}
        </button>
      </AniLink>
    )
  }
  return (
    <button style={animationStyle} onClick={onPress} className={`px-4 font-bold ${alternate ? "bg-transparent text-primary underline border-2 border-primary" : "bg-primary text-white"} ${!noHoverEffect && "hover:shadow-2xl"} rounded-lg ${classes}`}>
      {children}
    </button>
  )
}

export default Button